import { userConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { forgotPassEffect } from '../_effects';
import { alertActions } from './alertActions';
import value from 'environment';

export const fortgotPassActions = {
  forgotPass,
};

function forgotPass(pwd, values) {
  return (dispatch) => {
    dispatch(request(pwd));
    forgotPassEffect.forgotPassSet(pwd).then(
      (pass) => {
        dispatch(success(pass));
        if (pass.data.statusCode === '200') {
          history.push({ pathname: '/reset-password', state: values });
        }
        // else {
        //   history.push('/forgot-password');
        // }
      },
      (error) => {
        console.log('action pass error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(pass) {
    return { type: userConstants.FORGOTPASS_REQUEST, pass };
  }
  function success(pass) {
    return { type: userConstants.FORGOTPASS_SUCCESS, pass };
  }
  function failure(error) {
    return { type: userConstants.FORGOTPASS_FAILURE, error };
  }
}
